// TypeScript
import {useMemo} from 'react';
import {useFormik} from 'formik';
import dayjs from '../../../services/customDayJs';
import {dateFormat, dateFromDateTillValidationSchema, VoicemailsFormProps} from '../utils/VoicemailsDialog.utils';

type UseVoicemailsFilterArgs = {
    timezoneOffset: number;
    userDateTimeFormat: string;
    onSubmit: (form: VoicemailsFormProps) => void; // tu wstrzykujesz np. getVoicemails
    defaultValues?: Partial<VoicemailsFormProps>;
};

export const useVoicemailsFilter = (
    {
        timezoneOffset,
        userDateTimeFormat,
        onSubmit,
        defaultValues,
    }: UseVoicemailsFilterArgs) => {
    const initialValues = useMemo<VoicemailsFormProps>(
        () => ({
            from:
                defaultValues?.from ??
                dayjs.utc().utcOffset(timezoneOffset / 60).subtract(1, 'month').format(dateFormat),
            till: defaultValues?.till ?? dayjs.utc().utcOffset(timezoneOffset / 60).format(dateFormat),
            cli: defaultValues?.cli ?? '',
            cld: defaultValues?.cld ?? '',
        }),
        [timezoneOffset, defaultValues?.from, defaultValues?.till, defaultValues?.cli, defaultValues?.cld],
    );

    const formik = useFormik<VoicemailsFormProps>({
        initialValues,
        onSubmit,
        validationSchema: dateFromDateTillValidationSchema(timezoneOffset, userDateTimeFormat),
        enableReinitialize: true,
        validateOnChange: false,
    });

    const onFromChange = (v: string) => formik.setFieldValue('from', v);
    const onTillChange = (v: string) => formik.setFieldValue('till', v);
    const onCliChange = (v: string) => formik.setFieldValue('cli', v);
    const onCldChange = (v: string) => formik.setFieldValue('cld', v);
    const onSearchClick = () => formik.handleSubmit();

    return {
        values: formik.values,
        errors: formik.errors,
        handleSubmit: formik.handleSubmit as (e?: React.FormEvent) => void,
        setFieldError: formik.setFieldError,
        resetForm: formik.resetForm,
        onFromChange,
        onTillChange,
        onCliChange,
        onCldChange,
        onSearchClick,
    };
};
